import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useIntegrationContext } from '../../IntegrationProvider';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Property from '@afosto/app-components-react/Property';
import isDefined from '@afosto/utils/isDefined';
import {
  array as arrayFormatter,
  boolean as booleanFormatter,
} from '@afosto/app-components-react/DataGrid/formatters';
import translations from './translations';

const IntegrationApp = () => {
  const intl = useIntl();
  const { app } = useIntegrationContext();

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <Box px={2} pb={2}>
        <Property label={intl.formatMessage(translations.properties.name)} value={app?.name} />
        <Property
          label={intl.formatMessage(translations.properties.description)}
          value={app?.description}
        />
        <Property
          label={intl.formatMessage(translations.properties.authorName)}
          value={app?.author?.name}
        />
        <Property
          label={intl.formatMessage(translations.properties.multipleIntegrationsAllowed)}
          value={
            isDefined(app?.is_duplicate_allowed)
              ? booleanFormatter(app.is_duplicate_allowed)
              : undefined
          }
        />
        <Property
          label={intl.formatMessage(translations.properties.tags)}
          value={isDefined(app?.tags) ? arrayFormatter(app.tags) : undefined}
        />
      </Box>
    </Card>
  );
};

export default IntegrationApp;
